import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styles from './Layout.module.css';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider, useAuth } from '../Context/AuthContext';

const Layout: React.FC = () => {
  return (
    <AuthProvider>
      <LayoutContent />
    </AuthProvider>
  );
};

const LayoutContent: React.FC = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    const token = localStorage.getItem('webToken');
  
    if (!token) {
      navigate('/breathe-ev-admin/login');
    }
  
    if (token && !user && !isLoading) {
      navigate('/breathe-ev-admin/login');
    }
  }, [user, isLoading, navigate]);

  return (
    <main>

      {isLoading ?
        <>
          loading...
        </>
        :
        <>
          <Header />
          <div className={styles['main-container']}><Outlet /></div>
          <Footer />
        </>
      }

    </main>
  );
};

export default Layout;
